export const OraTypography = {
  fontFamily: 'var(--font-family-base)',
};
